const CROSS_MATCH_BANNER_IMAGE = "/img/kuaguo.jpg";

const CROSS_MATCH_CARD_KEYS = [
  "privateButler",
  "invitationManagement",
  "globalMatch",
  "hotelDiscount",
  "itineraryManagement",
];

module.exports = {
  CROSS_MATCH_BANNER_IMAGE,
  CROSS_MATCH_CARD_KEYS,
};
